import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  RecordPicker,
  useCacheRecord,
} from 'gossamer-front-end';
import { AdminCreateAttendanceRequest, Attendance, BookingView } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';

interface AdminCreateAttendanceForMemberModalProps {
  userId: string;
}

export const AdminCreateAttendanceForMemberButton = (props: AdminCreateAttendanceForMemberModalProps) => {
  const [bookingId, setBookingId] = React.useState<number | null>(null);
  const record = useCacheRecord(BookingView, bookingId === null ? null : String(bookingId));
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // const resetCache = makeResetCache(dispatch);
  // prevent infinite re-render
  const nowToMinute = new Date();
  nowToMinute.setMilliseconds(0);
  nowToMinute.setSeconds(0);

  const handleClick = async () => {
    navigate(`/admin/attendance/create/${bookingId}`);
    // try {
    //   const response = await fetchApi('POST', `/main/admin-create-attendance`, {
    //     ticketBookingId: bookingId,
    //   } as AdminCreateAttendanceRequest);
    //   resetCache(Attendance.id);
    //   setBookingId(null);
    //   notifyResponse(response);
    // } catch (e) {
    //   notifyError(e, 'Failed to create attendance record');
    // }
  };
  return (
    <InputGroup>
      <InputGroup.Text>Manually create an Attendance Record</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={(newValue: string) => setBookingId(parseInt(newValue))}
        value={bookingId === null ? null : String(bookingId)}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Event',
          refEntity: BookingView,
        }}
        queryOptions={{
          where: {
            and: [
              getFilter('attendance_id', 'bl', '', 'hidden'),
              getFilter('user_id', 'eq', props.userId, 'hidden'),
              getFilter('start_at', 'lt', nowToMinute.toISOString(), 'hidden'),
              getFilter('booking_status', 'eq', 'active', 'hidden'),
            ],
          },
          order: [['start_at', 'DESC']],
        }}
      />
      <Button size="sm" variant="primary" disabled={!record.data} onClick={handleClick}>
        Add
      </Button>
    </InputGroup>
  );
};
